import React from 'react';
import Reflux from 'reflux';
import EventInfo from '../../components/edp/eventinfo';
import EventInfoStore from '../../stores/eventinfo';
import ModalStore from '../../stores/modal';
import EventConfigStore from '../../stores/edpconfig';

export default class EventInfoContainer extends Reflux.Component {
  constructor (props) {
    super(props);

    this.state = {};
    this.mapStoreToStateKey(EventInfoStore, 'eventinfo');
    this.mapStoreToStateKey(ModalStore, 'modal');
    this.mapStoreToStateKey(EventConfigStore, 'eventconfig');
  }

  mapStoreToStateKey = (store, key) => {
    this.mapStoreToState(store, changes => {
      this.setState(currentState => ({ [key]: {...currentState[key], ...changes} }));
    });
  };

  render () {
    return <EventInfo {...this.state.eventinfo}  modal={this.state.modal} eventconfig={this.state.eventconfig} />;
  }
};



// WEBPACK FOOTER //
// ./frontend/react/apps/eventInfoHeader/index.js